import { render, staticRenderFns } from "./EditDistributor.vue?vue&type=template&id=c49cb65a&scoped=true"
import script from "./EditDistributor.vue?vue&type=script&lang=js"
export * from "./EditDistributor.vue?vue&type=script&lang=js"
import style0 from "./EditDistributor.vue?vue&type=style&index=0&id=c49cb65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49cb65a",
  null
  
)

export default component.exports